import { render, staticRenderFns } from "./InstantQuote.vue?vue&type=template&id=640b4e56&scoped=true&"
import script from "./InstantQuote.vue?vue&type=script&lang=js&"
export * from "./InstantQuote.vue?vue&type=script&lang=js&"
import style0 from "./InstantQuote.vue?vue&type=style&index=0&id=640b4e56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640b4e56",
  null
  
)

export default component.exports